module.exports = __webpack_public_path__ + "static/media/9_potolok_12.6_0.22606572.png";